var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ref_widgetEchartsBar",staticClass:"widget-view",style:({
    width: this.$util.num2px(_vm.viewProps.width),
    height: this.$util.num2px(_vm.viewProps.height)
})})
}
var staticRenderFns = []

export { render, staticRenderFns }